module.exports = __webpack_public_path__ + "static/media/hn-hoan-kiem.d9bfc7ea.svg";